import Vue from "vue";

export const showToast = (message, type = "success", theme = "toasted-primary", options = {}) => {
    const defaultOptions = {
      position: "top-center",
      duration: 5000,
      action: [
        {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      ],
      theme,
      type,
    };
  
    const toastOptions = { ...defaultOptions, ...options };
  
    Vue.toasted.show(message, toastOptions);
};